import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-0  disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        dark: "bg-[#252A31] text-primary-foreground shadow hover:bg-accent hover:text-accent-foreground",
        flat: "bg-transparent",
      },
      size: {
        default: "h-[2.5rem] px-[0.875rem] py-[0.625rem] rounded-lg leading-[1.5rem] font-semibold",
        sm: "h-8 rounded-lg px-3 text-xs",
        lg: "h-[2.75rem] rounded-lg px-[1.125rem] py-[0.625rem] leading-[1.5rem] font-semibold",
        xl: "h-[3rem] rounded-lg px-[1.25rem] py-[1.25rem] leading-[1.5rem] font-semibold",
        xxl: "h-[3.75rem] rounded-lg px-[2.75rem] py-[1rem] leading-[1.5rem] font-semibold text-[1.375rem]",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
